import { UserService } from '@ospace/auth'
import { EditUserProfileRequest } from '@ospace/schemas'
import { Storage } from '@ospace/shared'
import { notifications } from '@mantine/notifications'
import { useMutation, useQueryClient } from 'react-query'

export const useUserProfileMutation = () => {
  const queryClient = useQueryClient()

  return useMutation(
    async (user: EditUserProfileRequest & { avatarFile: File }) => {
      if (user.avatarFile) {
        await Storage().put(`users/${user.identityId}/${user.avatarFile.name}`, user.avatarFile)
      }
      return await UserService.editProfile(
        user?.identityId as string,
        {
          ...user,
          avatar: user.avatarFile ? `users/${user.identityId}/${user.avatarFile.name}` : null,
        } as any
      )
    },
    {
      onSuccess: (data: any) => {
        notifications.show({
          color: 'green',
          message: 'You have successfully updated user profile.',
        })

        queryClient.invalidateQueries(['user', data?.identityId])
        queryClient.refetchQueries(['users'])
      },
      onError: (e: any) => {
        notifications.show({
          color: 'red',
          message: e.response?.data || e.message,
        })
      },
    }
  )
}
